import {
  useIsCustomerLoggedIn,
  useRefetchCustomerData,
} from '@aboutyou/legacy-shared'
import useShowLoginPrompt from 'helpers/hooks/useShowLoginPrompt'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import React from 'react'
import { useUserStore } from 'store/context'
import styled from 'styled-components'
import { Icon } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import * as colors from 'uiComponents/constants/colors'

const Like: React.FC<{
  className?: string
  liked: boolean
  brandId: string
  brandUrl: string
}> = ({ className, liked, brandId, brandUrl }) => {
  const userStore = useUserStore()
  const isLoggedIn = useIsCustomerLoggedIn()
  const refetchCustomerData = useRefetchCustomerData()
  const { TrackingClient } = useTracking()
  const showLoginPrompt = useShowLoginPrompt()

  const handleOnClick = async () => {
    if (isLoggedIn) {
      await userStore.likeBrand(brandId, !liked)
      refetchCustomerData()
    } else {
      showLoginPrompt('legacy-brand-overview-brand-like-button')
    }

    TrackingClient?.trackContentInteraction({
      interaction: {
        action: liked ? 'unlike' : 'like',
        label: brandId,
        name: brandUrl.split('/').reverse()[0],
        type: 'brand',
        url: brandUrl,
      },
    })
  }

  return (
    <button className={className} type="button" onClick={handleOnClick}>
      <StyledIcon $isLiked={liked} asset={IconName.IcWishlist} />
    </button>
  )
}

const StyledIcon = styled(Icon)<{ $isLiked: boolean }>`
  fill: ${colors.white};
  stroke: ${colors.primaryColor};
  stroke-width: 2px;
  ${({ $isLiked }) => $isLiked && `fill: ${colors.primaryColor};`}

  &:hover {
    fill: ${colors.primaryColor};
  }
`

export default Like
